const DARK_MODE_KEY = "darkMode";

class LocalStorage {
	static remove = (key: string) => {
		window.localStorage.removeItem(key);
	};

	static set = (key: string, value: unknown) => {
		window.localStorage.setItem(key, JSON.stringify(value));
	};

	static get = (key: string) => {
		const value = window.localStorage.getItem(key);
		if (!value) {
			return null;
		}
		return JSON.parse(value);
	};

	static isDarkMode = (): boolean => {
		return LocalStorage.get(DARK_MODE_KEY) ?? false;
	};

	static setDarkMode = (enabled: boolean): void => {
		LocalStorage.set(DARK_MODE_KEY, enabled);
	};
}

export default LocalStorage;
